import { getDefaultConfig } from "@rainbow-me/rainbowkit";
import { arbitrum, base, mainnet, optimism, bsc } from "wagmi/chains";
import {
  okxWallet,
  rainbowWallet,
  walletConnectWallet,
  metaMaskWallet,
} from "@rainbow-me/rainbowkit/wallets";

import customMainnetIcon from "@/assets/eth.png";
const isMobile = window.innerWidth <= 768;
const wallets = [
  {
    groupName: "Recommended",
    wallets: [
      isMobile ? okxWallet : metaMaskWallet,
      okxWallet,
      rainbowWallet,
      walletConnectWallet,
    ],
  },
];

export const config = getDefaultConfig({
  wallets,
  multiInjectedProviderDiscovery: false,
  chains: [
    bsc,
    {
      ...mainnet,
      iconUrl: customMainnetIcon,
    },
  ],
  appName: "xi",
  projectId: "044c66086cb8327d181af50c4de08257",
});
